export default class AuthTypeRequest {

	public readonly email: string;

	public constructor(email: string) {
		this.email = email;
	}

}
